export default {
  getStaffAlertRequest: false,
  getStaffAlertSuccess: false,
  getStaffAlertFailed: false,
  getStaffAlertErrors: null,
  staffAlerts: [],
  nextStaffAlert: null,

  updateStaffAlertRequest: false,
  updateStaffAlertSuccess: false,
  updateStaffAlertFailed: false,
  updateStaffAlertErrors: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/alerts/state.js